<nz-list>
    <nz-list-item *ngFor="let document of documents">
        <a target="_blank" [href]="mediaPreviewdUrl + document.path"><i nz-icon nzType="file"
                nzTheme="outline"></i> {{document.originalname}}</a>
    </nz-list-item>
</nz-list>